// extracted by mini-css-extract-plugin
export default {"pharmaFilterContainer":"PharmaFilter_pharmaFilterContainer__nNZ-L","pharmaFilterTitle":"PharmaFilter_pharmaFilterTitle__aDQK2","fielterField":"PharmaFilter_fielterField__dwP2V"};